import { TranslationsFR } from './translations/fr';
import { TranslationsSR } from './translations/sr';
import { TranslationsFI } from './translations/fi';
import { TranslationsNB } from './translations/nb';
import { TranslationsES } from './translations/es';
import { TranslationsDA } from './translations/da';
import { TranslationsDE } from './translations/de';
import { TranslationsZH } from './translations/zh';
import { TranslationsTH } from './translations/th';
import { TranslationsID } from './translations/id';
import { TranslationsIT } from './translations/it';
import { TranslationsAR } from './translations/ar';
import { TranslationsVI } from './translations/vi';
import { TranslationsPA } from './translations/pa';
import { TranslationsPT } from './translations/pt';
import { TranslationsSV } from './translations/sv';
import { TranslationsJA } from './translations/ja';
import { TranslationsKM } from './translations/km';
import { TranslationsEL } from './translations/el';
import { TranslationsEN } from './translations/en';
import { TranslationsBG } from './translations/bg';
import { TranslationsHI } from './translations/hi';
import { TranslationsKO } from './translations/ko';
import { TranslationsRU } from './translations/ru';
import { TranslationsTR } from './translations/tr';
import { TranslationsNL } from './translations/nl';
import { TranslationsPL } from './translations/pl';
import { TranslationsMS } from './translations/ms';
import { TranslationsRO } from './translations/ro';
import { TranslationsCS } from './translations/cs';
import { TranslationsHU } from './translations/hu';
import { TranslationsTA } from './translations/ta';
import { TranslationsTE } from './translations/te';
import { TranslationsBN } from './translations/bn';
import { TranslationsZHT } from './translations/zht';
import { TranslationsSK } from './translations/sk';
import { TranslationsHE } from './translations/he';
import { TranslationsSQ } from './translations/sq';
export const TRANSLATION_MAPPING = [
    { language: 'fr', keys: TranslationsFR },
    { language: 'en', keys: TranslationsEN },
    { language: 'sr', keys: TranslationsSR },
    { language: 'fi', keys: TranslationsFI },
    { language: 'nb', keys: TranslationsNB },
    { language: 'es', keys: TranslationsES },
    { language: 'da', keys: TranslationsDA },
    { language: 'de', keys: TranslationsDE },
    { language: 'zh', keys: TranslationsZH },
    { language: 'th', keys: TranslationsTH },
    { language: 'id', keys: TranslationsID },
    { language: 'it', keys: TranslationsIT },
    { language: 'ar', keys: TranslationsAR },
    { language: 'vi', keys: TranslationsVI },
    { language: 'pa', keys: TranslationsPA },
    { language: 'pt', keys: TranslationsPT },
    { language: 'sv', keys: TranslationsSV },
    { language: 'ja', keys: TranslationsJA },
    { language: 'km', keys: TranslationsKM },
    { language: 'el', keys: TranslationsEL },
    { language: 'bg', keys: TranslationsBG },
    { language: 'hi', keys: TranslationsHI },
    { language: 'ko', keys: TranslationsKO },
    { language: 'ru', keys: TranslationsRU },
    { language: 'tr', keys: TranslationsTR },
    { language: 'nl', keys: TranslationsNL },
    { language: 'pl', keys: TranslationsPL },
    { language: 'ms', keys: TranslationsMS },
    { language: 'ro', keys: TranslationsRO },
    { language: 'cs', keys: TranslationsCS },
    { language: 'hu', keys: TranslationsHU },
    { language: 'ta', keys: TranslationsTA },
    { language: 'te', keys: TranslationsTE },
    { language: 'bn', keys: TranslationsBN },
    { language: 'zht', keys: TranslationsZHT },
    { language: 'sk', keys: TranslationsSK },
    { language: 'he', keys: TranslationsHE },
    { language: 'sq', keys: TranslationsSQ },
];
/** Language codes with a translation bundle (the only values `?lang=` / `data-lang` accept). */
export const SUPPORTED_LANGUAGE_CODES = TRANSLATION_MAPPING.map(m => m.language);
export function isSupportedLanguage(code) {
    return typeof code === 'string' && SUPPORTED_LANGUAGE_CODES.includes(code);
}
//# sourceMappingURL=constants.js.map